/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type RehypeSettled = {
  rehypeState: Address;
  launch: Address;
  claimedBase: bigint;
  claimedQuote: bigint;
  beneficiaryBase: bigint;
  beneficiaryQuote: bigint;
  lpBase: bigint;
  lpQuote: bigint;
};

export type RehypeSettledArgs = {
  rehypeState: Address;
  launch: Address;
  claimedBase: number | bigint;
  claimedQuote: number | bigint;
  beneficiaryBase: number | bigint;
  beneficiaryQuote: number | bigint;
  lpBase: number | bigint;
  lpQuote: number | bigint;
};

export function getRehypeSettledEncoder(): FixedSizeEncoder<RehypeSettledArgs> {
  return getStructEncoder([
    ['rehypeState', getAddressEncoder()],
    ['launch', getAddressEncoder()],
    ['claimedBase', getU64Encoder()],
    ['claimedQuote', getU64Encoder()],
    ['beneficiaryBase', getU64Encoder()],
    ['beneficiaryQuote', getU64Encoder()],
    ['lpBase', getU64Encoder()],
    ['lpQuote', getU64Encoder()],
  ]);
}

export function getRehypeSettledDecoder(): FixedSizeDecoder<RehypeSettled> {
  return getStructDecoder([
    ['rehypeState', getAddressDecoder()],
    ['launch', getAddressDecoder()],
    ['claimedBase', getU64Decoder()],
    ['claimedQuote', getU64Decoder()],
    ['beneficiaryBase', getU64Decoder()],
    ['beneficiaryQuote', getU64Decoder()],
    ['lpBase', getU64Decoder()],
    ['lpQuote', getU64Decoder()],
  ]);
}

export function getRehypeSettledCodec(): FixedSizeCodec<
  RehypeSettledArgs,
  RehypeSettled
> {
  return combineCodec(getRehypeSettledEncoder(), getRehypeSettledDecoder());
}
